export const AudioLibrary = {
    'Focus Entrainment': {
        path: require('../../assets/audio/FOCUS_ENTRAINMENT.m4a'),
        name: 'Focus Entrainment'
    },

    'Gamma Music 1': {
        path: require('../../assets/audio/GAMMA_MUSIC_1.m4a'),
        name: 'Gamma Music 1'
    },
    
    'Gamma ocean surf and chimes': {
        path: require('../../assets/audio/GAMMA_OCEAN_SURF_AND_CHIMES.m4a'),
        name: 'Gamma ocean surf and chimes'
    }
}
